/**
 * @tabler/icons-react v2.39.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTriangleInverted = createReactComponent(
  "triangle-inverted",
  "IconTriangleInverted",
  [
    [
      "path",
      {
        d: "M10.363 20.405l-8.106 -13.534a1.914 1.914 0 0 1 1.636 -2.871h16.214a1.914 1.914 0 0 1 1.636 2.871l-8.106 13.534a1.914 1.914 0 0 1 -3.274 0z",
        key: "svg-0"
      }
    ]
  ]
);

export { IconTriangleInverted as default };
//# sourceMappingURL=IconTriangleInverted.js.map
